<div>
  <h5 class="m-t-15">
    <span>{{ question.name }}</span>
  </h5>
</div>
<div *ngIf="question.answers" class="card-body p-t-10 p-b-10">
  <div *ngFor="let answer of question.answers">
    <i [ngClass]="(getIsCheckbox())?'ti-layout-width-full':'fa fa-circle-thin'" class="list-answers"></i>
    <span *ngIf="getIsRating()" class="m-l-10">{{ answer.order }}</span>
    <span class="answer-text">{{ answer.name }}</span>
    <span *ngIf="getIsSatisfactionRate()"
      class="satisfaction-rate"
      [class.positive]="answer.answerCategoryType === answerCategoryType.SatisfactionRatePositive"
      [class.neutral]="answer.answerCategoryType === answerCategoryType.SatisfactionRateNeutral"
      [class.negative]="answer.answerCategoryType === answerCategoryType.SatisfactionRateNegative">
    </span>
  </div>
</div>